module.exports = __webpack_public_path__ + "img/scalpel-line-dashed.67134246.svg";